import React, { useState, useEffect } from "react";
import ReactPaginate from 'react-paginate';
import ReviewSummary from './Reviews/Summary';
import ReviewItem from './Reviews/Review';
import ReviewForm from './Reviews/ReviewForm';
const ListingReviews = (props) => {
  const { listing, currentUser, loginPath } = props;
  const [isLoading, setIsLoading] = useState(false);
  const [reviews, setReviews] = useState([])
  const [reviewsMeta, setReviewsMeta] = useState({})
  const fetchReviews = async (page = 1) => {
    setIsLoading(true)
    fetch(`/listing/${listing.slug}/reviews?page=${page}`, {
      method: 'GET',
      headers: {
        "Content-Type": "application/json",
        "X-CSRF-Token": document.querySelector('meta[name="csrf-token"]')
          ?.content,
      },
    }).then((resp) => {
      return resp.json();
    }).then((resp) => {
      setIsLoading(false);
      setReviews(resp.resources);
      setReviewsMeta(resp.meta);
    }).catch((error) => {
      console.log('error', error);
      setIsLoading(false);
    })
  }
  const handlePageChange = (pg) => {
    fetchReviews(+pg.selected + 1)
  }
  const handleSubmitted = (e) => {
    fetchReviews();
  }
  const removePlaceholders = () => {
    document.querySelectorAll('.review-placeholdder').forEach(e => {
      e.remove();
    })
  }
  useEffect(() => {
    removePlaceholders()
    fetchReviews();
  }, []);
  return (
    <React.Fragment>
      {
        reviews.map((review) => (
          <ReviewItem key={review.id} review={review} listing={listing} />
        ))
      }
      {
        reviewsMeta.pages > 1 && <div className="row">
          <div className="col-md-12">

            <div className="utf_pagination_container_part margin-top-30">


              <nav className="pagination">
                <ReactPaginate
                  breakLabel="..."
                  previousLabel={<i className="sl sl-icon-arrow-left"></i>}
                  nextLabel={<i className="sl sl-icon-arrow-right"></i>}
                  pageRangeDisplayed={3}
                  pageCount={reviewsMeta.pages}
                  renderOnZeroPageCount={null}
                  onPageChange={handlePageChange}
                  activeClassName="selected"
                  previousClassName="previous"
                  nextClassName="next"
                />

              </nav>
            </div>
          </div>
        </div>
      }

      <ReviewForm
        listing={listing}
        currentUser={currentUser}
        loginPath={loginPath}
        existingReview={reviewsMeta.my_review}
        onSubmitted={handleSubmitted}
      />
    </React.Fragment>
  );
};

export default ListingReviews;
